import React from 'react';
import Joi from 'joi';
import PropTypes from 'prop-types';

import AutTable from '../../blocks/aut-grid-table/index';
import Conditional from '../../common/conditional';
import ETWallThicknessItemForm from './etWallThicknessItemForm';
import Form from '../../common/form';

import * as models from '../../../utils/models';
import * as data from '../../../utils/data';

class ETWallThicknessDataForm extends Form {
	state = {
		data: { items: [] },
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		items: Joi.array()
			.min(1)
			.items(
				Joi.object({
					srNo: Joi.number().positive().min(1).required().label('SR/NO'),
					flangeWidth: Joi.number()
						.positive()
						.required()
						.label('Flange Width (mm)'),
					flangeThickness: Joi.number()
						.positive()
						.required()
						.label('Flange Thickness (mm)'),
					webLength: Joi.number()
						.positive()
						.required()
						.label('Web Length (mm)'),
					webThickness: Joi.number()
						.positive()
						.required()
						.label('Web Thickness (mm)'),
					diameter: Joi.number().required().label('Diameter (inches)'),
				})
			)
			.required()
			.label('Inspection Items'),
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	onAddItem = (item: models.ETWallThicknessItem) => {
		const data: any = { ...this.state.data };
		data.items = [...data.items];
		data.items.push({ ...item, srNo: data.items.length + 1 });

		this.setState({ data });
	};

	onDeleteItem = (item: models.ETWallThicknessItem): void => {
		const data = { ...this.state.data };
		data.items = data.items.filter(
			(i: models.ETWallThicknessItem) => i.srNo !== item.srNo
		);

		this.setState({ data });
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data.items);

		this.setState({ data: { items: [] } });
	};

	render() {
		return (
			<React.Fragment>
				<ETWallThicknessItemForm onAdd={this.onAddItem} />

				<AutTable
					tableColumns={data.getETWallThicknessTableColumns()}
					data={this.state.data.items}
					onDeleteItem={this.onDeleteItem}
				/>

				<Conditional isVisible={this.state.data.items.length > 0}>
					<form autoComplete="off" onSubmit={this.handleSubmit}>
						{this.renderButton('Finish')}
					</form>
				</Conditional>
			</React.Fragment>
		);
	}
}

export default ETWallThicknessDataForm;
